export default __webpack_public_path__ + "static/media/Alte_Goetter_Hoerprobe.ebe5a42b.mp3";